export default __webpack_public_path__ + "static/media/graph.adba29e7.png";